import React from "react";
import { Link } from "react-router-dom";

const Pagination = ({ page, pages, keyword = "", basePath = "" }) => {
  const currentPage = Number(page || 1);
  const totalPages = Number(pages || 1);

  if (totalPages <= 1) return null;

  return (
    <nav>
      <ul className="pagination justify-content-center mt-2">
        {[...Array(totalPages).keys()].map((x) => {
          const pageNumber = x + 1;

          let path = "";

          if (keyword) {
            path = `${basePath}/search/${keyword}/page/${pageNumber}`;
          } else if (basePath) {
            path = pageNumber === 1 ? `${basePath}` : `${basePath}/page/${pageNumber}`;
          } else {
            path = `/page/${pageNumber}`;
          }

          return (
            <li
              className={`page-item ${pageNumber === currentPage ? "active" : ""}`}
              key={pageNumber}
            >
              <Link className="page-link" to={path}>
                {pageNumber}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Pagination;